<template>
<modal title="Select Environment">
  <select-input 
    :items="avaialbleEnvs"
    v-model="environment"
    label-key="name"
    value-key="id">
    Environment
  </select-input>

  <template #footer>
    <div class="buttons">
      <action-button @click="select">Select</action-button>
    </div>
  </template>
</modal>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  props: {
    environments: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    environment: ''
  }),

  methods: {
    select() {
      this.$close(this.environment)
    }
  },

  computed: {
    ...mapGetters('app', [
      'dashboard'
    ]),
    avaialbleEnvs() {
      return this.environments.filter(env => env.id !== this.dashboard.environment.id)
    }
  }

}
</script>